const NAMESPACE = "_app-base";

const KEYS = {
    defaultDialogTitle: "defaultDialogTitle"
};

const MESSAGES = {
    [KEYS.defaultDialogTitle]: {
        value: "Are you sure?",
        comment: "Default title text for confirmation dialog"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
